export const INTEGRATIONS_COPY = {
	// eslint-disable-next-line max-len
	CHOOSE_PROJECT: 'If you have multiple projects in your Jira instance, you can optionally choose a single project to display in Status Mapping and in the Jira search in Initiatives',
	CONNECT_JIRA:
	// eslint-disable-next-line max-len
	'Use your credentials to link Jira to Arovy.  After we\'re hooked up, we\'ll map your Jira statuses to Arovy statuses.',
	EDIT_JIRA_SETTINGS: 'Edit Jira Integration Settings',
	GENERATE_SLACK_LINK:
	// eslint-disable-next-line max-len
	'Click this button to generate your Slack authorization link. Once a link is generated, you will have 15 minutes before this link expires to connect Arovy to Slack.',
	INSTANCE_URL: 'Instance URL',
	JIRA_HELP_URL: 'https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/',
	JIRA_PROJECT_FILTER: 'Jira Project Filter',
	JIRA_STATUS: 'Jira Status',
	JIRA_URL: 'Jira Url',
	JIRA_URL_PLACEHOLDER: 'https://jira.arovy.com',
	MAP_JIRA:
	// eslint-disable-next-line max-len
	'Map your Jira statuses to Arovy statuses.  If you mark a Jira ticket as primary in an Initiative, the Initiative will use Jira as the source of truth for its status.',
	OIDC_LOGIN: 'Validating login...',
	SALESFORCE_ORG_REAUTH_FAILURE: 'There was an issue reauthenticating the organization',
	SALESFORCE_ORG_REAUTH_SUCCESS: 'Successfully reauthenticated the organization',
	URL_USING_FOR_JIRA: 'The URL you are using to log into Jira.',
	WEBHOOK_URL: 'Webhook URL'
};
